import {Component, HostListener, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Observable} from 'rxjs';

import {UserGuideService} from '../../shared/user-guide.service';
import {EditEventModalComponent} from '@src/app/components_2.1/edit-event-modal/edit-event-modal.component';
import {CustomerStoriesModalComponent} from '@src/app/components_2.1/customer-stories-modal/customer-stories-modal.component';
import {SignUpModalComponent} from '@modules/user-guide/modals/sign-up-modal/sign-up-modal.component';
import {IUserGuide, IUserGuideActiveStep} from '../../shared/user-guide.model';
import {UserGuideStore} from '../../shared/user-guide.store';

@Component({
  selector: 'app-user-guide',
  templateUrl: './user-guide.component.html',
  styleUrls: ['./user-guide.component.scss'],
})
export class UserGuideComponent implements OnInit {
  userGuide$: Observable<IUserGuide[]>;
  isDrawerOpen$: Observable<boolean>;
  activeStep$: Observable<IUserGuideActiveStep>;

  constructor(
    private userGuideService: UserGuideService,
    private userGuideStore: UserGuideStore,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.isDrawerOpen$ = this.userGuideService.isDrawerOpen$.asObservable();
    this.userGuide$ = this.userGuideStore.userGuide$;
    this.activeStep$ = this.userGuideStore.activeStep$;
  }

  @HostListener('window:click', ['$event'])
  onElementClick($event: MouseEvent) {
    this.userGuideService.clickedElement = $event.composedPath();
  }

  @HostListener('window:beforeunload', ['$event'])
  openLoseEventProgressWarning($event: BeforeUnloadEvent): void {
    if (this.userGuideService.showLoseEventProgressWarning) {
      $event.preventDefault();
      $event.returnValue = 'Changes that you made may not be saved.';
    }
  }

  openEditEventModal() {
    this.dialog.open(EditEventModalComponent);
  }

  openUserStoriesModal() {
    this.dialog.open(CustomerStoriesModalComponent);
  }

  openSignUpModal() {
    this.dialog.open(SignUpModalComponent);
  }
}
